let stores = [];
let mode = "";

const modalStoreElms = {
  modal: document.querySelector(".store"),
  close: document.querySelector(".store .container-modal .close-modal"),
  title: document.querySelector(".store .container-modal .content .title h4"),
  overlay: document.querySelector(".modal-overlay"),
  footer: document.querySelector(".store .container-modal .modal-footer"),
  button: document.querySelector(
    ".store .container-modal .modal-footer .submit-store"
  ),
  continue: document.querySelector(".btn-continue.submit-store"),
};

const setStore = (value) => {
  stores = value;
  renderStores(stores);
  setStorageModalStore();
};

const timeToMinutes = (time) => {
  if (!time) return 0;
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

const renderStores = (storesData) => {
  const list = $("#stores-list");
  const template = $("#store-template");
  list.empty();

  list.find(".store-available__info").remove();

  if (storesData.length !== 0) {
    const storeLocal = JSON.parse(localStorage.getItem("stores"));
    for (let store of storesData) {
      const cloned = template.contents().clone();

      cloned.find(".name").text(store.name);
      cloned.find(".address").text(store.address);

      if (mode === "view")
        cloned.find("input#pick-store").prop("disabled", true);
      cloned.find("input#pick-store").val(JSON.stringify(store));
      if (store.tag?.name) {
        cloned
          .find(".state-pick")
          .addClass(`${store.tag?.code === "no_available" ? "error" : ""}`);
        if (store.tag?.code === "available") {
          cloned.find(".state-pick").text("Envío desde otra bodega");
          cloned.find(".state-pick").addClass("warning");
        } else if (store.tag?.code === "immediate_removal") {
          const hourInitial = timeToMinutes(store?.schedule?.split("-")[0]);
          const hourEnd = timeToMinutes(store?.schedule?.split("-")[1]);
          const dateNow = new Date();
          const dateSantiago = dateNow.toLocaleString("es-CL", {
            timeZone: "America/Santiago",
          });
          const [hoursantiagoNow, minutesantiago] = dateSantiago
            .split(" ")[1]
            .split(":")
            .map(Number);
          const hourSantiago = timeToMinutes(
            `${hoursantiagoNow}: ${minutesantiago}`
          );

          if (hourSantiago >= hourInitial && hourSantiago < hourEnd) {
            cloned.find(".state-pick").text("Disponible");
          } else {
            cloned.find(".state-pick").text("Retira mañana");
          }
        } else {
          cloned.find(".state-pick").text(store.tag.name);
        }
        cloned.find(".state-pick").removeClass("hidden");
      }

      if (store.id === storeLocal?.id && mode !== "view") {
        cloned.find("input#pick-store").prop("checked", true);

        cloned.prependTo(list);
      } else {
        cloned.appendTo(list);
      }
    }
    return;
  }
  list.append('<p class="store-not-found">No hay tiendas disponibles</p>');
};

const getStores = async () => {
  const response = await axios.get(`${baseUrlOMS}/api/v1/store/`, fetchConfig);
  const data = response?.data?.data;
  if (data) return setStore(data);
  console.error("get stores error");
};

const getLines = () => {
  const isPoductPage = $("body").hasClass("template-product");
  const isCartPage = $("body").hasClass("template-cart");

  if (isPoductPage) {
    const variant = document.querySelector('[name="current_variant"]')?.value;
    if (!variant) return false;

    const currentVariant = JSON.parse(variant)[0];
    return [{ sku: currentVariant?.sku }];
  }

  if (isCartPage) {
    if (lastOptionSelected?.method !== acceptedMethods.tienda) return false;

    return [{ sku: lastOptionSelected?.line?.sku }];
  }

  return false;
};

const getTagStores = async () => {
  const lines = getLines();
  if (!lines) return;

  const body = {
    lines,
    deliveries: [{ method_code: "Tienda", warehouse_code: "" }],
  };

  const response = await axios.post(
    `${baseUrlOMS}/api/v1/store/`,
    body,
    fetchConfig
  );
  const tagStores = response?.data?.store;

  if (tagStores) {
    const newStore = stores.map((store) => {
      const tagStore = tagStores.find((tStore) => tStore.code === store.code);
      return tagStore?.tag ? { ...store, tag: tagStore.tag } : store;
    });

    return setStore(newStore);
  }

  console.error("get stores error");
};

const _openModal = async (mode) => {
  document.body.style.overflow = "hidden";
  await getRegionsOms("store");
  const isAccount = document.querySelector(".store.account");
  let _element = document.getElementById("message-store");
  if (!_element?.classList?.contains("hidden"))
    _element.classList.add("hidden");

  if (storeStorage && !isAccount) setStorageModalStore();
  if (mode === "view") {
    modalStoreElms.continue.classList.add("hidden");
    modalStoreElms.title.textContent = "Ver disponibilidad en tienda";
    modalStoreElms.modal.classList.add("not-has-hover");
    modalStoreElms.footer.classList.add("d-none");
  }
  modalStoreElms.modal.classList.add("open");
  modalStoreElms.overlay.classList.add("open");
};

const setStorageSelection = () => {
  const shippingMethod = localStorage.getItem("selectedMethod");
  document.getElementById(shippingMethod).checked = true;

  if (shippingMethod.includes("Delivery")) {
    document.getElementById("shipping-location").classList.add("active");
    document
      .getElementById("container-radio-mobile")
      .classList.remove("d-none");
    return;
  }
  if (shippingMethod === "DeliverySuc") {
    document.getElementById("shipping-chilexpress").classList.add("active");
    document.getElementById("container-radio-mobile").classList.add("d-none");
    return;
  }
};


const _closeModalStore = (opt) => {
  document.body.style.overflow = "auto";
  modalStoreElms.modal.classList.remove("open");
  modalStoreElms.overlay.classList.remove("open");
  if ($("#grouped-products").hasClass("d-none") && opt === 'icon-close' ){ stopLoaderSelect(); }
  if (!storeStorage) setStorageSelection();
};

const removeStoreFilter = (selectType) => {
  $(document).ready(function () {
    if (selectType === "region") {
      $("#select-region-store").toggleClass("active");
      $("#select-btn-region-store span").text("Region");
      $("#select-btn-comune-store span").text("Comuna");
      return renderStores(stores);
    }

    $("#select-comune-store").toggleClass("active");
    $("#select-btn-comune-store span").text("Comuna");
    if ($("#select-btn-region-store span").text() === "Region") return;

    const selectBtnRegions = document.getElementById("region-oms-store");
    const regionAttr = JSON.parse(
      selectBtnRegions.options[selectBtnRegions.selectedIndex].getAttribute(
        "data-info"
      )
    );

    if (!regionAttr?.code) {
      $("#comuna-oms-store option:not(:first)").remove();
    } else {
      const filteredStores = stores.filter((store) => {
        return store.state.code === regionAttr.code;
      });
      renderStores(filteredStores);
    }
  });
};

// Event listeners
window.addEventListener("is-open-modal-store", (e) => {
  if (!e?.detail?.open) return _closeModalStore();
  mode = e.detail.mode;
  _openModal(e.detail.mode);
  getStores();

  if (e?.detail?.module !== "account") return getTagStores();
});

modalStoreElms.close.addEventListener("click", () => _closeModalStore('icon-close'));
/* modalStoreElms.continue.addEventListener("click", _closeModal);
 */
